export default {
    initTDMap: function () {
        // const AK = "ac4574b214e137c925e5abfbd7bba5b8";
        const AK = "02631667e924c737aa677c9049759695";
        // const AK = "64b4329e39f231dbf79149f3196a81df";
        const apiVersion = "3.0";
        const timestamp = new Date().getTime();
        const TDMap_URL = "https://api.tianditu.gov.cn/api?v=" + apiVersion + "&tk=" + AK + "&services=&t=" + timestamp;

        return new Promise((resolve, reject) => {
            if (typeof TMap !== "undefined") {
                resolve(TMap);
                return true;
            }
            // 插入script脚本
            let scriptNode = document.createElement("script");
            scriptNode.setAttribute("type", "text/javascript");
            scriptNode.setAttribute("src", TDMap_URL);

            document.body.appendChild(scriptNode);

            // 等待页面加载完毕回调
            let timeout = 0;
            let interval = setInterval(() => {
                // 超时10秒加载失败
                if (timeout >= 20) {
                    reject();
                    clearInterval(interval);
                    console.error("地图脚本初始化失败...");
                }
                // 加载成功
                if (typeof TMap !== "undefined") {
                    resolve(TMap);
                    clearInterval(interval);
                    console.log("地图脚本初始化成功...");
                }
                timeout += 1;
            }, 500);
        });
    },
    initBMap: function () {
        console.log("初始化百度地图脚本...");
        const AK = "ESslwtC1IqbGBPsFiGztMAc22KtHnG2y";
        const apiVersion = "3.0";
        const timestamp = new Date().getTime();
        const BMap_URL = "http://api.map.baidu.com/getscript?v=" + apiVersion + "&ak=" + AK + "&services=&t=" + timestamp;
        return new Promise((resolve, reject) => {
            if (typeof BMap !== "undefined") {
                resolve(BMap);
                return true;
            }

            // 插入script脚本
            let scriptNode = document.createElement("script");
            scriptNode.setAttribute("type", "text/javascript");
            scriptNode.setAttribute("src", BMap_URL);

            document.body.appendChild(scriptNode);

            // 等待页面加载完毕回调
            let timeout = 0;
            let interval = setInterval(() => {
                // 超时10秒加载失败
                if (timeout >= 20) {
                    reject();
                    clearInterval(interval);
                    console.error("百度地图脚本初始化失败...");
                }
                // 加载成功
                if (typeof BMap !== "undefined") {
                    console.log(BMap, 'BMap---');
                    resolve(BMap);
                    clearInterval(interval);
                    console.log("百度地图脚本初始化成功...");
                }
                timeout += 1;
            }, 500);
        });
    }
}
